/* eslint-disable */
import axios from "axios";

import decryptData from "@/store/auth/decryptData";

export default {
  namespaced: true,
  state: () => ({
    pendingData: [],
    completedData: [],
    cancelledData: [],
    inProgressData: [],
    taskLoaded: false
  }),
  mutations: {
    setTaskLoaded(state, payload) {
      state.taskLoaded = payload;
    },
    SET_TASKS(state, task) {
      state.pendingData = task.pending;
      state.completedData = task.completed;
      state.cancelledData = task.cancelled;
      state.inProgressData = task.inProgress;
      state.taskLoaded = true;
    }
  },
  actions: {
    async fetchTasks({ commit, state }) {
     
        const res = await axios.get(
          "https://gulftic-system.fci.group/api/task/all?status"
        );
        const data = decryptData(res.data.payload).data.tasks;
        const pending = data.filter(item => item.status === "pending");
        const completed = data.filter(item => item.status === "completed");
        const cancelled = data.filter(item => item.status === "cancelled");
        const inProgress = data.filter(item => item.status === "in-progress");
        const formatted = {
          pending,
          completed,
          cancelled,
          inProgress
        };
        commit("SET_TASKS", formatted);
      }
  },
  getters: {
    pendingData: state => state.pendingData,
    completedData: state => state.completedData,
    cancelledData: state => state.cancelledData,
    inProgressData: state => state.inProgressData,
    taskLoaded: state => state.taskLoaded
  }
};
